import { Options, Vue } from "vue-class-component";
import Toggle from "@vueform/toggle";

import { ErrorType } from "@/interfaces/error";

@Options({
  name: "newsletter-new",
  components: {
    Toggle,
  },
})
export default class NewsletterNew extends Vue {
  public errorMessage = "";
  public errors: ErrorType = {};
  public hasError = false;
  public row = {
    description: "",
    enabled: true,
  };

  public goBack() {
    this.$router.push("/newsletter");
  }

  public validation() {
    this.errors = {};
    this.hasError = false;

    // this.row.city = this.row.city?.trim();

    if (!this.row.description) {
      this.errors.description = "Este campo deve ser preenchido.";
      this.hasError = true;
    }

    return !this.hasError;
  }

  public save() {
    if (this.validation()) {
      this.$store
        .dispatch("newsletter/insert", {
          description: this.row.description,
          enabled: this.row.enabled,
        })
        .then(() => {
          this.$router.push("/newsletter");
        })
        .catch(() => {
          this.errorMessage = "Ocorreu um erro ao gravar o registro.";
        });
    }
  }
}
